import { API_ROUTE_ADMIN_COST_OBJECT_SWITCH_NUMBER_TO_COMPANY } from '@/resources/api-routes'
import { post } from '@/util/auth'

export const switchToCompanyNumber = (costObjectId: number) =>
  post<boolean>(
    API_ROUTE_ADMIN_COST_OBJECT_SWITCH_NUMBER_TO_COMPANY.replace(
      ':costObjectId',
      String(costObjectId)
    )
  )
